var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h3", [_vm._v("Basic usage | 基本使用")]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: { dataset: _vm.sampleData, config: _vm.treeConfig },
      }),
      _vm._v(" "),
      _c("h3", [
        _vm._v("Show different style with folded nodes | 异化展示折叠节点"),
      ]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: { dataset: _vm.sampleData, config: _vm.treeConfig },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "span",
                  {
                    staticClass: "tree-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [_vm._v(_vm._s(node.value))]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Rich media tree chart | 富媒体树状图")]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: { dataset: _vm.richMediaData, config: _vm.treeConfig },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "48px",
                        height: "48px",
                        "border-raduis": "4px",
                      },
                      attrs: { src: node.avatar },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值" + _vm._s(node.value))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Link nodes with straight line | 直线连接")]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: {
          dataset: _vm.richMediaData,
          config: _vm.treeConfig,
          linkStyle: "straight",
        },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "48px",
                        height: "48px",
                        "border-raduis": "4px",
                      },
                      attrs: { src: node.avatar },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值" + _vm._s(node.value))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Horizontal tree chart | 横向树状图")]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: {
          dataset: _vm.richMediaData,
          config: _vm.treeConfig,
          direction: "horizontal",
        },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "48px",
                        height: "48px",
                        "border-raduis": "4px",
                      },
                      attrs: { src: node.avatar },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值" + _vm._s(node.value))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Zoom in or out | 缩放")]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c(
            "v-btn",
            {
              on: {
                click: function ($event) {
                  return _vm.controlScale("bigger")
                },
              },
            },
            [_vm._v("+")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              on: {
                click: function ($event) {
                  return _vm.controlScale("smaller")
                },
              },
            },
            [_vm._v("-")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              on: {
                click: function ($event) {
                  return _vm.controlScale("restore")
                },
              },
            },
            [_vm._v("1:1")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("vue-tree", {
        ref: "scaleTree",
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: { dataset: _vm.richMediaData, config: _vm.treeConfig },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "48px",
                        height: "48px",
                        "border-raduis": "4px",
                      },
                      attrs: { src: node.avatar },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值" + _vm._s(node.value))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n    Example of multiple parents with node collapse disabled |\n    支持多父节点(禁用折叠)\n  "
        ),
      ]),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: {
          dataset: _vm.vehicules,
          config: _vm.treeConfig,
          "collapse-enabled": false,
          linkStyle: "straight",
        },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值 " + _vm._s(node.name))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n    Example of multi-root with changing dataset | 多根节点, 支持切换数据源\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "changeDataset",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.clicked = !_vm.clicked
            },
          },
        },
        [_vm._v("\n    Change dataset\n  ")]
      ),
      _vm._v(" "),
      _c("vue-tree", {
        staticStyle: {
          width: "800px",
          height: "600px",
          border: "1px solid gray",
        },
        attrs: {
          dataset: _vm.multiRootChoice,
          config: _vm.treeConfig,
          "collapse-enabled": true,
          linkStyle: "straight",
        },
        scopedSlots: _vm._u([
          {
            key: "node",
            fn: function (ref) {
              var node = ref.node
              var collapsed = ref.collapsed
              return [
                _c(
                  "div",
                  {
                    staticClass: "rich-media-node",
                    style: { border: collapsed ? "2px solid grey" : "" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "4px 0",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("能力值 " + _vm._s(node.name))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }